import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { Typography, Box } from '@material-ui/core';
import globals from '../../../../globals/communityGlobals';
import PostcodeSearch from './../../../../containers/common/PostcodeSearch/PostcodeSearchContainer';
import AddressForm from '../../../../components/Treatments/AddressDetails/AddressForm';
import { refSetter } from '../../../../utils/helpers';

const locale = globals.getArea('nonPatientActivities');

export const actionTypes = {
  edit: 'EDIT',
  create: 'CREATE',
  view: 'VIEW',
};

class NonPatientAddressDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: props.actionType === actionTypes.edit ? true : null,
    };
  }

  setRef = refSetter.bind(this);

  handleChange = () => {
    this.setState({
      isValid: true,
    });
  };

  updateAddressFromPostcode = selection => {
    this.addressForm.setValue({
      addressLine1: selection.lines[0],
      addressLine2: selection.lines[1],
      addressLine3: selection.lines[2],
      townCity: selection.postTown,
      postCode: selection.value,
    });
  };

  render() {
    const { isValid } = this.state;
    const { innerRef, setValidity, activityAddress } = this.props;

    return (
      <Box display="flex" flexDirection="column">
        <Box p={1}>
          <Typography variant="h6">{locale.getMsg('activityAddress')}</Typography>
        </Box>
        <Box display="flex" flexDirection="row">
          <Box flexGrow={1}>
            <Formsy.Form
              ref={innerRef}
              onChange={this.handleChange}
              onValid={setValidity(isValid)}
              onInvalid={setValidity(isValid)}
            >
              <div className="row">
                <PostcodeSearch onSelect={this.updateAddressFromPostcode} />
              </div>
              <AddressForm
                ref={this.setRef('addressForm')}
                value={activityAddress}
                name="address"
                disabled
                accessDetailsDisabled={false}
              />
            </Formsy.Form>
          </Box>
        </Box>
      </Box>
    );
  }
}

NonPatientAddressDetails.defaultProps = {
  onFieldsUpdate: () => {},
  innerRef: () => {},
  setValidity: () => {},
  addressDetails: undefined,
  readOnly: false,
  activityAddress: undefined,
};

NonPatientAddressDetails.propTypes = {
  innerRef: PropTypes.func,
  setValidity: PropTypes.func,
  activityAddress: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    townCity: PropTypes.string,
    postCode: PropTypes.string,
    accessDetails: PropTypes.string,
  }),
  actionType: PropTypes.string.isRequired,
};

export default NonPatientAddressDetails;
